import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bycullatopunecabservice() {



  const cardData = {


  keyword: "Byculla to Pune Cab Service",

  headingDescription: "Trustline Cab provides dependable Byculla to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, railway station transfers, family vacations, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our experienced chauffeurs ensure punctual pickups, smooth travel via the Mumbai-Pune Expressway, and a hassle-free journey from Byculla to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, professional drivers, well-maintained vehicles, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Byculla to Pune taxi services.",

  topPlaces: [
    {
      title: "Viman Nagar",
      description: "Viman Nagar is one of Pune's prime commercial and residential destinations, located close to Pune Airport. It features IT companies, premium hotels, shopping malls, restaurants, educational institutions, and excellent connectivity, making it a preferred location for business and leisure travelers."
    },
    {
      title: "Wakad",
      description: "Wakad is a rapidly developing suburb known for its IT professionals, commercial complexes, modern residential projects, restaurants, and seamless connectivity to Hinjewadi, Baner, and other major business hubs."
    },
    {
      title: "Kondhwa",
      description: "Kondhwa is a well-established residential and commercial locality offering business centers, hospitals, educational institutions, shopping complexes, and convenient access to major areas across Pune."
    },
    {
      title: "Ranjangaon MIDC",
      description: "Ranjangaon MIDC is one of Maharashtra's leading industrial corridors, housing automobile manufacturers, engineering companies, pharmaceutical industries, warehouses, and logistics centers. It is a key destination for industrial and corporate travel."
    },
    {
      title: "Balewadi High Street",
      description: "Balewadi High Street is a vibrant lifestyle and commercial destination featuring premium restaurants, cafés, offices, retail stores, entertainment venues, and modern business spaces. It is popular among professionals and visitors."
    },
    {
      title: "Pune Airport",
      description: "Pune Airport is a major aviation hub connecting Pune with important cities across India. It serves business travelers, tourists, and passengers requiring reliable airport transfer services."
    },
    {
      title: "Shaniwar Wada",
      description: "Shaniwar Wada is Pune's iconic historical fort, admired for its magnificent Maratha architecture, cultural significance, and evening light-and-sound show. It remains one of the city's most visited heritage attractions."
    },
    {
      title: "Pataleshwar Cave Temple",
      description: "Pataleshwar Cave Temple is an ancient rock-cut temple famous for its impressive stone architecture, peaceful surroundings, and historical importance. It attracts visitors interested in history, culture, and spirituality."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station located between Mumbai and Pune, renowned for waterfalls, lush green valleys, viewpoints, caves, and pleasant weather. It is one of the most popular weekend destinations in Maharashtra."
    },
    {
      title: "Karla Caves",
      description: "Karla Caves are ancient Buddhist rock-cut caves near Lonavala, celebrated for their remarkable architecture, intricate carvings, and historical significance. They are among the most popular tourist attractions on the Mumbai–Pune route."
    }
  ],






"services": [
  {
    "name": "Byculla to Pune Cab Service Rates",
    "description": "Book Byculla to Pune Cab Service at affordable fixed rates with clean AC Sedan, Ertiga, Innova, Innova Crysta, and SUV vehicles. Enjoy professional chauffeurs, doorstep pickup, transparent pricing, online booking, one way and round trip travel, luggage assistance, corporate transfers, family trips, and 24x7 customer support."
  },
  {
    "name": "Byculla to Pune Taxi Service",
    "description": "Choose Byculla to Pune Taxi Service for safe and comfortable outstation travel with experienced drivers, sanitized vehicles, flexible pickup timings, affordable fares, airport transfers, and reliable highway journeys."
  },
  {
    "name": "Mahalaxmi to Pune Cab Service",
    "description": "Book Mahalaxmi to Pune Cab Service with fixed pricing, AC vehicles, professional chauffeurs, instant booking confirmation, and comfortable intercity transportation."
  },
  {
    "name": "Colaba to Pune Taxi",
    "description": "Reserve Colaba to Pune Taxi for business trips, family travel, airport transfers, one way rides, and round trip journeys with premium chauffeur-driven cars."
  },
  {
    "name": "Parel to Pune Cab Service",
    "description": "Hire Parel to Pune Cab Service with clean AC vehicles, experienced drivers, fixed fares, online reservations, and dependable outstation transportation."
  },
  {
    "name": "Sion to Pune Cab Booking",
    "description": "Complete Sion to Pune Cab Booking online with instant confirmation, transparent pricing, multiple vehicle options, and professional drivers."
  },
  {
    "name": "Wadala to Pune Cab Booking",
    "description": "Book Wadala to Pune Cab Booking with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles for comfortable and hassle-free travel."
  },
  {
    "name": "Byculla Cabs Service",
    "description": "Choose Byculla Cabs Service for local rides, airport transfers, and outstation journeys with reliable chauffeurs, well-maintained vehicles, and affordable pricing."
  },
  {
    "name": "Outstation Cab Service in Byculla",
    "description": "Hire Outstation Cab Service in Byculla for Pune, Mumbai Airport, Nashik, Lonavala, Shirdi, and other destinations with fixed fares and 24x7 availability."
  },
  {
    "name": "Outstation Cab Service in Byculla Number",
    "description": "Contact our Outstation Cab Service in Byculla Number for instant booking assistance, fare details, vehicle availability, and professional travel support."
  },
  {
    "name": "Outstation Cab Service in Byculla Number Mumbai",
    "description": "Get the Outstation Cab Service in Byculla Mumbai for quick reservations, transparent pricing, experienced chauffeurs, and premium customer assistance."
  },
  {
    "name": "Byculla to Pune Cab",
    "description": "Book Byculla to Pune Cab with fixed fares, comfortable AC vehicles, professional drivers, doorstep pickup, one way and round trip options, airport transfers, and reliable outstation travel."
  },
  {
    "name": "Byculla to Pune Cab Service",
    "description": "Our Byculla to Pune Cab Service offers Sedan, Ertiga, Innova, Innova Crysta, SUV, and luxury vehicles with affordable pricing, punctual pickup, and experienced chauffeurs."
  },
  {
    "name": "Byculla to Pune Taxi Service",
    "description": "Travel with Byculla to Pune Taxi Service offering clean vehicles, transparent pricing, flexible pickup timing, luggage assistance, and comfortable highway journeys."
  },
  {
    "name": "Byculla to Pune One Way Cab",
    "description": "Choose Byculla to Pune One Way Cab for direct travel with affordable fares, professional chauffeurs, AC vehicles, and instant online booking."
  },
  {
    "name": "Byculla to Pune Taxi Fare",
    "description": "Check Byculla to Pune Taxi Fare with transparent pricing, fixed packages, multiple cab categories, and no hidden charges."
  },
  {
    "name": "Byculla to Pune Cab Booking",
    "description": "Complete Byculla to Pune Cab Booking online with instant confirmation, secure reservations, multiple vehicle options, and 24x7 customer support."
  },
  {
    "name": "Cab from Byculla to Pune",
    "description": "Book a Cab from Byculla to Pune for business travel, family vacations, airport transfers, corporate trips, and comfortable intercity journeys."
  },
  {
    "name": "Byculla to Pune Car Rental",
    "description": "Hire Byculla to Pune Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for flexible travel plans."
  },
  {
    "name": "Byculla to Pune Taxi Booking Online",
    "description": "Reserve Byculla to Pune Taxi Booking Online with instant confirmation, transparent pricing, multiple vehicle choices, and reliable customer support."
  },
  {
    "name": "Cheap Cab Byculla to Pune",
    "description": "Book Cheap Cab Byculla to Pune with economical fares, clean AC vehicles, professional drivers, and dependable one way or round trip service."
  },
  {
    "name": "Byculla to Pune Outstation Cab",
    "description": "Choose Byculla to Pune Outstation Cab for safe long-distance travel with fixed fares, experienced chauffeurs, comfortable vehicles, and 24x7 availability."
  },
  {
    "name": "Byculla to Pune AC Taxi Service",
    "description": "Travel comfortably with Byculla to Pune AC Taxi Service featuring air-conditioned vehicles, smooth highway rides, affordable fares, and professional drivers."
  },
  {
    "name": "Byculla to Pune Innova Cab",
    "description": "Reserve Byculla to Pune Innova Cab for family travel, corporate tours, airport transfers, group journeys, and spacious seating with extra luggage capacity."
  },
  {
    "name": "Byculla to Pune SUV Taxi",
    "description": "Book Byculla to Pune SUV Taxi with premium SUVs for luxury travel, family vacations, business trips, and comfortable long-distance journeys."
  },
  {
    "name": "Byculla to Pune Cab Price",
    "description": "Check Byculla to Pune Cab Price with fixed packages, transparent billing, multiple vehicle options, and affordable rates for one way and round trip travel."
  }
],

"tableData": [
  ["Byculla to Pune Cab Service Rates", "Byculla to Pune Taxi Service"],
  ["Mahalaxmi to Pune Cab Service", "Colaba to Pune Taxi"],
  ["Parel to Pune Cab Service", "Sion to Pune Cab Booking"],
  ["Wadala to Pune Cab Booking", "Byculla Cabs Service"],
  ["Outstation Cab Service in Byculla", "Outstation Cab Service in Byculla Number"],
  ["Outstation Cab Service in Byculla Number Mumbai", "Byculla to Pune Cab"],
  ["Byculla to Pune Cab Service", "Byculla to Pune Taxi Service"],
  ["Byculla to Pune One Way Cab", "Byculla to Pune Taxi Fare"],
  ["Byculla to Pune Cab Booking", "Cab from Byculla to Pune"],
  ["Byculla to Pune Car Rental", "Byculla to Pune Taxi Booking Online"],
  ["Cheap Cab Byculla to Pune", "Byculla to Pune Outstation Cab"],
  ["Byculla to Pune AC Taxi Service", "Byculla to Pune Innova Cab"],
  ["Byculla to Pune SUV Taxi", "Byculla to Pune Cab Price"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Byculla to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab provides dependable Byculla to Pune cab services with experienced chauffeurs, comfortable vehicles, and seamless intercity travel for every passenger."
  },
  {
    WhyChooseheading: "Convenient Pickup from Byculla",
    WhyChoosedescription: "Enjoy doorstep pickup from Byculla East, Byculla West, Byculla Railway Station, hotels, offices, hospitals, and residential areas with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Safe & Comfortable Highway Journey",
    WhyChoosedescription: "Our professional drivers ensure a smooth and secure ride through the Mumbai–Pune Expressway with punctual pickups and efficient route planning."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Every Trip",
    WhyChoosedescription: "Select from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your travel requirements, passenger count, and luggage."
  },
  {
    WhyChooseheading: "Transparent Fare with Affordable Pricing",
    WhyChoosedescription: "Receive a detailed fare quotation before booking with competitive pricing and complete transparency without hidden charges."
  },
  {
    WhyChooseheading: "One Way & Round Trip Cab Options",
    WhyChoosedescription: "Book one-way cabs, return journeys, or customized travel packages according to your travel schedule and destination."
  },
  {
    WhyChooseheading: "Suitable for Business, Family & Airport Travel",
    WhyChoosedescription: "Our Byculla to Pune cab service is ideal for corporate meetings, airport transfers, family trips, medical visits, and personal travel."
  },
  {
    WhyChooseheading: "24/7 Booking & Customer Assistance",
    WhyChoosedescription: "Book your Byculla to Pune cab anytime with instant confirmation and dedicated customer support for a hassle-free journey."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Byculla to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Byculla to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Byculla to Pune?",
    answer: "Yes, one-way cab services are available with doorstep pickup from Byculla and direct drop anywhere in Pune."
  },
  {
    question: "Do you provide pickup from Byculla Railway Station?",
    answer: "Yes, we provide pickup from Byculla Railway Station, Byculla East, Byculla West, hotels, offices, hospitals, and nearby Mumbai locations."
  },
  {
    question: "Which vehicles are available for Byculla to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable long-distance travel."
  },
  {
    question: "Is Byculla to Pune cab service available 24 hours?",
    answer: "Yes, our cab service operates 24/7, allowing you to travel according to your preferred schedule."
  },
  {
    question: "Can I reserve a return cab from Pune to Byculla?",
    answer: "Yes, round-trip cab services are available for passengers planning return travel between Pune and Byculla."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically included in the confirmed booking quotation."
  },
  {
    question: "Should I reserve my Byculla to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and your preferred pickup timing."
  },
  {
    question: "Do you provide Byculla to Pune cabs for corporate travel?",
    answer: "Yes, our cab services are suitable for business meetings, executive travel, employee transportation, and client visits."
  },
  {
    question: "How can I book Byculla to Pune Cab Service with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Pratik Mehra",
    feedback: "Trustline Travels provided an outstanding Byculla to Pune cab service with a punctual driver, spotless vehicle, and a smooth, comfortable journey. Everything was managed professionally from pickup to drop.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sonam Kulkarni",
    feedback: "Our experience was excellent from the moment we booked the cab. The driver was courteous, the vehicle was spacious, and the journey from Byculla to Pune was relaxing and completely hassle-free.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Byculla to Pune Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/byculla-to-pune-cab-service.webp",
  "description":
    "Book Byculla to Pune Cab Service with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Byculla, Mahalaxmi, Colaba, Parel, Sion, Wadala, and nearby Mumbai locations to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/byculla-to-pune-cab-service"
  }
};



  return (
    <div>
<Helmet>
  <title>Byculla to Pune Cab Service | One Way Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Byculla to Pune Cab Service with Trustline Travels for reliable one-way and round-trip taxi services. Travel from Byculla, Mahalaxmi, Colaba, Parel, Sion, Wadala, and nearby Mumbai areas to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Byculla to pune cab service rates, byculla to pune taxi service, mahalaxmi to pune cab service, colaba to pune taxi, parel to pune cab service, sion to pune cab booking, wadala to pune cab booking, Byculla to Pune Cab Service, Byculla Pune Taxi, one way cab byculla to pune, byculla cab service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bycullatopunecabservice;